import React from "react";
import { HashLink } from "react-router-hash-link";

export const Internship = ({ data }) => {
  if (!data) return null;

  return (
    <div id="internship" className="text-center">
      <div className="container">

        <div className="section-title">
          {/* SEO H1 */}
          <h1>{data.title}</h1>
          <p>{data.intro}</p>
        </div>

        <div className="row">

          {/* Internship Domains */}
          <div className="col-md-6">
            <h2>Internship Domains</h2>
            <ul className="list-unstyled">
              {data.domains.map((item, index) => (
                <li key={index}>✔ {item}</li>
              ))}
            </ul>
          </div>

          {/* Internship Benefits */}
          <div className="col-md-6">
            <h2>Why Choose Our Internship?</h2>
            <ul className="list-unstyled">
              {data.benefits.map((item, index) => (
                <li key={index}>✔ {item}</li>
              ))}
            </ul>
          </div>

        </div>

        <div className="row" style={{ marginTop: "30px" }}>
          <div className="col-md-12">
            <h2>Who Can Apply?</h2>
            <p>{data.eligibility}</p>

            <HashLink smooth to="/#careers" className="btn btn-custom btn-lg">
              Apply for Internship
            </HashLink>
          </div>
        </div>

      </div>
    </div>
  );
};
